import styled from "styled-components";

export const Container = styled.div`
    float:left; 
    width:100%; 
    position:relative;  

   
`;

export const CadastrosCSS = styled.form`

    float:left; 
    width:100%; 
    position:relative;
    /* padding-top: 95px; */
    padding: 95px 20px;  

.back{
    position: absolute!Important;
    top: 10px!Important;
    right: 20px!Important
}

.tab-content > .active{
    border-left:1px #dee2e6  solid!important;
    border-right:1px #dee2e6  solid!important;
    border-bottom:1px #dee2e6  solid!important;
    padding: 1%;
}

.tab-content {
    .bq-warning {
        border-left: 3px solid #043c54 !important;
    }
}

.nav-tabs .nav-item{
    margin-bottom: 0px !important  
}

.nav-item.ativo{
    border-bottom: 1px #fff solid;
    margin-bottom: -1px !important  
}
.nav-item.ativo a {
    color: #043c54
}

.cliente{
    width:100%;
    float: left;
    position: relative;
    min-height: 250px;

    .bq-warning {
        border-left: 3px solid #043c54 !important;
    }
}
.store{
    width: 100%;
    float: left;
    position: relative;
    min-height: 250px;
}

.cliente input[type="text"], .store input[type="text"]{
    background: #f5f5f5!important;
}

label.active{
    border-radius: 5px!important;
}

.historico{
    width: 30%;
    float: left;
    position: relative;
    min-height: 250px;
    padding: 1%;
    display: none

}

.historico .button{
    width: 100%;
}

.historico h2{
    font-size: 16px;
    font-weight: 700;
    border-bottom: 1px #cdcdcd solid;
    padding: 1% 0;
}

.history{
    float: left;
    width: 100%;
    max-height: 600px;
    overflow: auto;
    border:1px #dee2e6  solid;
    padding: 1%;
    font-size: 14px;
}

.history .btn{
 padding: 0px 10px
}

.check{
    height: calc(1.0em + .5rem + 2px)!important;
    float: left;
    width: 30px;
    margin-top: 0;
}

.form-check-label {
    margin-bottom: 0;
    padding-left: 20px;
}

.form-check {
    position: relative;
    display: block;
    padding-left: 1.25rem;
}

.btrigth{
    float: right;
    margin: 0 1%;
}

.badge{
    padding: .40em 4em;
}

.md-form.md-outline{
    margin-top: 1rem;
    margin-bottom: 1rem;    
}

.sep{
    margin: 1% 0;
}

.mt-5, .my-5{
    margin-top: 0!important;
}

/*====================extrato=========*/

.extrato{
    width: 100%;
    float: left;
    position: relative;
    min-height: 250px;
    padding: 1%;
    
}

.extrato .button{
    width: 100%;
}

.extrato h2{
    font-size: 16px;
    font-height: 700;
    border-bottom: 1px #cdcdcd solid;
    padding: 1% 0;
}



 /*=========tabela====*/
 .resumo dl {
	display: table;
	width: 100%;
	border-bottom: 1px dotted #dbdbdb;
	padding: 1% 0;
}

.resumo dt {
	width: 20%;
	font-weight: 700;
	float: left;
	text-align:center;
	
}

.bg{
	background:#dbdbdb;	
	}

.resumo dd {
	display: inline-block;
	width: 20%;
	float: left;
	margin:0;
	opacity: 0.6;
	text-align:center
}

.conquistados{
	display: block;	
	max-height: 400px;
	overflow: auto;
}

.conquistados dl {
	display: table;
	width: 100%;
	border-bottom: 1px dotted #dbdbdb;
	padding: 1% 0;
}

.conquistados dt {
	width: 33.3%;
	font-weight: 700;
	float: left;
	text-align:center
}

.conquistados dd {
	display: inline-block;
	width: 33.3%;
	float: left;
	margin:0;
	opacity: 0.6;
	text-align:center
}

.indisponivel{
	width: 100% !important;
}

.bonus{
	display: block;
	max-height: 400px;
	overflow: auto;	
}

.bonus dl {
	display: table;
	width: 100%;
	border-bottom: 1px dotted #dbdbdb;
	padding: 1% 0;
}

.bonus dt {
	width: 33.3%;
	font-weight: 700;
	float: left;
	text-align:center
}

.bonus dd {
	display: inline-block;
	width: 33.3%;
	float: left;
	margin:0;
	opacity: 0.6;
	text-align:center
}

.expira{
	display: block;	
	max-height: 400px;
	overflow: auto;
}

.expira dl {
	display: table;
	width: 100%;
	border-bottom: 1px dotted #dbdbdb;
	padding: 1% 0;
}

.expira dt {
	width: 50%;
	font-weight: 700;
	float: left;
	text-align:center
}

.expira dd {
	display: inline-block;
	width: 50%;
	float: left;
	margin:0;
	opacity: 0.6;
	text-align:center
}

.resgatados{
	display: block;
	max-height: 400px;
	overflow: auto;	
}

.resgatados dl {
	display: table;
	width: 100%;
	border-bottom: 1px dotted #d8dde2;
	padding: 1% 0;
}

.resgatados dt {
	width: 25%;
	font-weight: 700;
	float: left;
	text-align:center
}

.resgatados dd {
	display: inline-block;
	width: 25%;
	float: left;
	margin:0;
	opacity: 0.6;
	text-align:center
}



/*==========acordeonn============*/
.acord{
  float:left;
  width: 100%;
  padding: 10px 20px;
  border: 1px #ddd solid;
  cursor: pointer;

}

.help{
    color: #fff;
    background: #da8b0f;
}

.escolhas{
  float:  left;
  width: 100%;
  padding: 15px;
  font-size: 12px;
  border: 1px #ddd solid;
}

.btn.gmb{
    padding: 5px 10px!important;
    border-radius: 5px!important;
}

.ql-editor{
    min-height: 150px;
}


.cliente input[type="text"].sld{
    background: #4c8a68!important;
    color: #fff;
}

.modaldetalhe{
    right: 0!important;
    min-height: 90%!important;
    height: 90%!important;
    top: 9%!important;
    left: 73%!important;
    width: 30%!important;

}

.modaldetalhe .modal-body{
    overflow-y: auto;
    overflow-x: hidden;
}



@media only screen and  (max-width: 1366px) {

    .history{
        max-height: 350px;
    }
    .modaldetalhe{
        right: 0!important;
        min-height: 90%!important;
        height: 90%!important;
        top: 10%!important;
        left:70%!important

    }

    .modaldetalhe .modal-body{
        overflow-y: auto;
        overflow-x: hidden;
    }



}


@media only screen and  (max-width: 1024px) {

    .history{
        max-height: 450px;
    }

}
@media only screen and  (max-width: 801px) {
    .cliente, .store, .historico{
        width: 100%;   
    }

}
@media only screen and  (max-width: 668px) {

}
@media only screen and  (max-width: 480px) {




}

`; 